import BubbleContent from 'core/modules/atoms/BubbleContent';
import i18next from 'i18next';
import React from 'react';
import { htmlToText } from './htmlToText';

export function isTabOneTool(currentTab) {
  return currentTab === 'cronometer' || currentTab === 'countdown' || currentTab === 'turn-of-speak';
}

// Como hacía stripHtml, el <audio> se quita entero: su texto de reserva («Your browser does not support…») no es título.
function toPlainText(html) {
  return htmlToText(html?.replaceAll(/<audio[\s\S]*?<\/audio>/gi, ''));
}

// El primer texto no vacío: un título del editor vacío (<p><br></p>) no tapa el párrafo ni el nombre del post.
function parsePost(post) {
  const parsePost = post.data ? post.data : post;
  const firstItem = parsePost?.items?.[0];
  const textItem = firstItem?.data?.type === 'text' || firstItem?.type === 'text' ? (firstItem.data ?? firstItem) : null;
  const firstText = textItem?.items?.[0];

  return [firstText?.heading, firstText?.paragraph, parsePost.name].map(toPlainText).find(Boolean) ?? '';
}

export function parseActivityName(item) {
  return toPlainText(item?.items?.length > 0 && item.items[0].data?.data ? item.items[0].data.data.stimulus : item.items[0].data.stimulus);
}

export function parseActivities(items, backgroundColor) {
  let newActivities = [];
  items.forEach((element) => {
    newActivities = [...newActivities, ...element.items.filter((item) => item.data?.type === 'lemonade' || item.type === 'lemonade')];
  });

  return newActivities
    .filter((item) => item.items?.length === 1)
    .map((item, index) => {
      return {
        ...item,
        guid: item.data?.id ? item.data?.id : item.id,
        customIcon: <BubbleContent number={index + 1} backgroundColor={backgroundColor} size="s" />,
        text: parseActivityName(item),
        type_name: i18next.t('assigments:Activity'),
        index: index + 1,
      };
    });
}

export function parseItemLesson(selectedLesson) {
  let itemsAnchors = [];
  if (selectedLesson?.guid && selectedLesson.posts && selectedLesson.posts.length > 0) {
    itemsAnchors = selectedLesson.posts.map((post) => ({
      type_name: i18next.t('lesson:Content'),
      type: 'mint',
      icon: 'file-text',
      text: parsePost(post),
      guid: post.guid,
    }));
  }

  return itemsAnchors;
}
export function parseItemsProjectionMint(lesson, backgroundColor) {
  return lesson ? [...parseItemLesson(lesson), ...parseActivities(lesson.posts, backgroundColor)] : [];
}
